import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: `https://l0uo7ib742.execute-api.ap-south-1.amazonaws.com/dev/`,
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })

}
